import React from 'react';
import { RecoilRoot } from 'recoil';
import Root from './Root';
// ==============================|| APP ||============================== //
import CustomToaster from 'ui-component/CustomToaster';


const App = () => {
  return (
    <RecoilRoot>
      <React.Suspense fallback={<div>Loading...</div>}>
        <Root />
        <CustomToaster />
      </React.Suspense>
    </RecoilRoot>
  );
};

export default App;
